import { useContext } from 'react'
import { useAppSelector } from '@/redux/hooks'
import { PersonalizedTheme } from '@itsrever/design-system'
import { ThemeOverrideContext } from './preview-contexts'

// The theme the preview renders with: an editor's unsaved theme when one is provided, otherwise
// the stored e-commerce theme. With no provider mounted this behaves as it always has.
export function usePortalTheme() {
  const override = useContext(ThemeOverrideContext)
  const settings = useAppSelector(
    (store) => store.settingsApi.settings.response
  )

  if (override) return override

  let theme: PersonalizedTheme = {}
  const settingsTheme = settings.theme
  if (settingsTheme) {
    theme = {
      colors: {
        primary: {
          main: settingsTheme.primary?.main,
          light: settingsTheme.primary?.light,
          dark: settingsTheme.primary?.dark,
          contrastText: settingsTheme.primary?.contrast_text
        },
        secondary: {
          main: settingsTheme.secondary?.main,
          light: settingsTheme.secondary?.light,
          dark: settingsTheme.secondary?.dark,
          contrastText: settingsTheme.secondary?.contrast_text
        }
      },
      borderRadius: settingsTheme.border_radius,
      inputVariant: settingsTheme.input_variant
    }
  }
  return theme
}
